// extracted by mini-css-extract-plugin
module.exports = {"root":"FancyBottledBeers_root__3VXSv","rootMobile":"FancyBottledBeers_rootMobile__ZOHMy"};